import DOMPurify from 'dompurify';

export const sanitizeUrl = (url: string | undefined): string => {
    if (!url) {
        return '';
    }
    return DOMPurify.sanitize(url, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
};

export const sanitizeHttpUrl = (url: string | undefined): string => {
    if (!url) {
        return '';
    }
    try {
        const { protocol } = new URL(url);
        return protocol === 'https:' || protocol === 'http:' ? url : '';
    } catch {
        return '';
    }
};
